<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
  },
  components: {},
  data() {
    return {
      d_check: this.selectedItem
        ? this.selectedItem[this.item.displayOn]
        : false,
    };
  },
  computed: {
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
  },
  watch: {
    selectedItem: {
      handler(val) {
        this.d_check = val ? val[this.item.displayOn] : false;
      },
      deep: true,
    },
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        }
      },
      deep: true,
    },
    display_none_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
  },
  mounted() {
    this.item.display = false;
  },
};
</script>
<template>
  <div
    class="mb-3"
    :class="{ 'd-none': item.displayOn && !display_none_check }"
  ></div>
</template>
